import { LoginCard } from '@/components/layout/LoginCard';
import { Button, Form, FormLabel, PasswordInput, PasswordRequirements, StandaloneLink } from '@/components/wm';
import { apiRequest } from '@/utils/request';
import * as React from 'react';
import { useState } from 'react';

export function ResetPassword({ onAlert, code, backToLogin }) {
    const
        [loading, setLoading] = useState(false),
        [password, setPassword] = useState(''),
        [passwordConfirmation, setPasswordConfirmation] = useState(''),
        [canSubmit, setCanSubmit] = useState(false);

    const handlePasswordChange = (newPwd, confirmPwd) => {
        setPassword(newPwd);
        setPasswordConfirmation(confirmPwd);
    };

    const handleRequirementsMet = isMet => {
        setCanSubmit(isMet);
    };

    const onHandleSubmit = async event => {
        event.preventDefault();
        setLoading(true);

        const data = {
            password,
            password_confirmation: passwordConfirmation
        };

        try {
            const response = await apiRequest(`/reset_password/${code}`, 'PUT', data);

            if (response.status === 200) {
                onAlert(i18next.t('ui.passwords.successfully_changed'), 'success', i18next.t('common.success'));
                backToLogin();
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred');

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'));
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    return (
        <div className="tw-grid tw-grid-cols-1">
            <LoginCard>
                <Form>
                    <FormLabel htmlFor="email">{i18next.t('ui.passwords.insert_new_password')}</FormLabel>
                    <PasswordInput
                        id="password"
                        onChange={e => setPassword(e.target.value)}
                        required
                        value={password}
                    />
                    <FormLabel htmlFor="email">{i18next.t('ui.passwords.confirm_new_password')}</FormLabel>
                    <PasswordInput
                        id="password_confirmation"
                        onChange={e => setPasswordConfirmation(e.target.value)}
                        required
                        value={passwordConfirmation}
                    />
                    <Button className="tw-w-full" disabled={!canSubmit} loading={loading} onClick={onHandleSubmit} type="submit" variant="secondary">
                        {i18next.t('ui.buttons.submit')}
                    </Button>
                </Form>
            </LoginCard>
            <PasswordRequirements
                confirmPassword={passwordConfirmation}
                newPassword={password}
                onPasswordChange={handlePasswordChange}
                onRequirementsMet={handleRequirementsMet}
            />
            {/* Back to Login */}
            <StandaloneLink icon="arrowLeftCircle" onAction={backToLogin} text={i18next.t('ui.passwords.back_to_login')}/>
        </div>
    );
}
